const es = {
  header: {
    badge: "Guía Oficial de BotMix",
    title: "Automatización de Felicitaciones de Cumpleaños",
    summary:
      "Automatiza el envío de saludos y mensajes afectuosos de cumpleaños por WhatsApp tanto a tus clientes como a tu equipo interno. Personaliza plantillas dinámicas con variables automáticas, hora fija de envío y anuncios internos para el equipo.",
  },
  sections: [
    {
      id: "cumpleanos_clientes",
      title: "1. Felicitación Automática a Clientes",
      description:
        "Fidelización y cercanía en el día especial de cada cliente.",
      items: [
        {
          id: "activacion_hora",
          title: "Hora de Envío y Conexión WhatsApp",
          definition:
            "Define la hora exacta del día (ej: 09:00 AM) y la línea telefónica de WhatsApp encargada de despachar las felicitaciones automáticas a quienes cumplan años en esa fecha.",
        },
        {
          id: "variables_dinamicas",
          title: "Variables Dinámicas Disponibles",
          definition:
            "Usa {nome} para insertar el nombre del cliente y {idade} para su edad calculada automáticamente desde su fecha de nacimiento registrada en CRM.",
        },
      ],
    },
    {
      id: "cumpleanos_equipo",
      title: "2. Celebración Interna del Equipo",
      description:
        "Reconocimiento y clima laboral con los colaboradores.",
      items: [
        {
          id: "anuncio_interno",
          title: "Avisos Internos de Cumpleaños",
          definition:
            "Activa anuncios en el panel de BotMix para que todo el equipo se entere de los cumpleaños de sus compañeros y puedan felicitarlos.",
        },
      ],
    },
  ],
};

const en = {
  header: {
    badge: "BotMix Official Guide",
    title: "Automated Birthday Greetings & Celebrations",
    summary:
      "Automate warm birthday greetings via WhatsApp for both customers and internal team members. Customize dynamic message templates with smart tags, schedule precise dispatch times, and broadcast internal team announcements.",
  },
  sections: [
    {
      id: "cumpleanos_clientes",
      title: "1. Customer Birthday Greetings",
      description:
        "Customer loyalty and relationship building on their special day.",
      items: [
        {
          id: "activacion_hora",
          title: "Dispatch Time & WhatsApp Channel",
          definition:
            "Configure the exact delivery hour (e.g., 09:00 AM) and select the WhatsApp number responsible for sending automated birthday wishes to contacts born on that day.",
        },
        {
          id: "variables_dinamicas",
          title: "Supported Dynamic Tags",
          definition:
            "Insert {nome} to include the client's first name and {idade} to mention their age calculated from the CRM birthdate record.",
        },
      ],
    },
    {
      id: "cumpleanos_equipo",
      title: "2. Internal Team Celebrations",
      description:
        "Fostering company culture and colleague appreciation.",
      items: [
        {
          id: "anuncio_interno",
          title: "Internal Dashboard Announcements",
          definition:
            "Trigger automated popups on the BotMix platform alerting all agents about co-workers' birthdays so the team can celebrate together.",
        },
      ],
    },
  ],
};

const pt = {
  header: {
    badge: "Guia Oficial BotMix",
    title: "Automação de Mensagens de Aniversário",
    summary:
      "Automatize o envio de saudações carinhosas de aniversário no WhatsApp para clientes e colaboradores. Personalize modelos de mensagens com variáveis dinâmicas, horário de envio diário e comunicados internos.",
  },
  sections: [
    {
      id: "cumpleanos_clientes",
      title: "1. Parabéns Automático para Clientes",
      description:
        "Fidelização e relacionamento próximo no dia especial do cliente.",
      items: [
        {
          id: "activacion_hora",
          title: "Horário de Disparo e Conexão WhatsApp",
          definition:
            "Defina o horário diário (ex: 09:00) e a linha do WhatsApp que realizará o envio das mensagens aos aniversariantes do dia.",
        },
        {
          id: "variables_dinamicas",
          title: "Variáveis Dinâmicas Disponíveis",
          definition:
            "Utilize {nome} para incluir o nome do contato e {idade} para inserir a idade calculada a partir da data de nascimento cadastrada no CRM.",
        },
      ],
    },
    {
      id: "cumpleanos_equipo",
      title: "2. Comemoração Interna da Equipe",
      description:
        "Reconhecimento e integração entre os colaboradores.",
      items: [
        {
          id: "anuncio_interno",
          title: "Avisos Internos na Plataforma",
          definition:
            "Exiba comunicados no painel do BotMix para avisar a equipe sobre os aniversários dos colegas de trabalho.",
        },
      ],
    },
  ],
};

const fr = {
  header: {
    badge: "Guide Officiel BotMix",
    title: "Automatisation des Vœux d'Anniversaire",
    summary:
      "Automatisez l'envoi de messages d'anniversaire chaleureux sur WhatsApp à vos clients et collaborateurs. Personnalisez des modèles dynamiques avec variables automatiques, heure d'envoi fixe et annonces d'équipe.",
  },
  sections: [
    {
      id: "cumpleanos_clientes",
      title: "1. Vœux Automatiques aux Clients",
      description:
        "Fidélisation et attention bienveillante pour le jour d'anniversaire.",
      items: [
        {
          id: "activacion_hora",
          title: "Heure d'Envoi et Ligne WhatsApp",
          definition:
            "Définissez l'heure exacte de diffusion (ex: 09h00) et la ligne WhatsApp chargée de féliciter les clients nés ce jour-là.",
        },
        {
          id: "variables_dinamicas",
          title: "Variables Dynamiques Intégrées",
          definition:
            "Insérez {nome} pour le nom du destinataire et {idade} pour son âge calculé automatiquement d'après sa fiche contact.",
        },
      ],
    },
    {
      id: "cumpleanos_equipo",
      title: "2. Célébration au Sein de l'Équipe",
      description:
        "Reconnaissance et cohésion interne entre collaborateurs.",
      items: [
        {
          id: "anuncio_interno",
          title: "Alertes Internes sur le Dashboard",
          definition:
            "Diffusez une notification dans BotMix pour informer l'équipe des anniversaires des collègues et célébrer ensemble.",
        },
      ],
    },
  ],
};

const ar = {
  header: {
    badge: "دليل BotMix الرسمي",
    title: "أتمتة تهاني أعياد الميلاد",
    summary:
      "أتمتة إرسال رسائل التهنئة والتحيات بمناسبة أعياد الميلاد عبر واتساب للعملاء وفريق العمل. تخصيص قوالب تفاعلية بمتغيرات ذكية، وقت إرسال محدد وإشعارات داخلية لفريق العمل.",
  },
  sections: [
    {
      id: "cumpleanos_clientes",
      title: "1. تهنئة العملاء تلقائياً",
      description:
        "بناء ولاء العملاء وتوطيد العلاقات في يومهم الخاص.",
      items: [
        {
          id: "activacion_hora",
          title: "وقت الإرسال وقناة واتساب",
          definition:
            "تحديد ساعة الإرسال اليومية (مثل: 09:00 صباحاً) ورقم واتساب المخصص لإرسال التهاني لمن يصادف عيد ميلادهم في ذلك اليوم.",
        },
        {
          id: "variables_dinamicas",
          title: "المتغيرات الذكية المدعومة",
          definition:
            "استخدام {nome} لإدراج اسم العميل و {idade} لذكر عمره المحسوب تلقائياً من تاريخ ميلاده المسجل في CRM.",
        },
      ],
    },
    {
      id: "cumpleanos_equipo",
      title: "2. الاحتفال الداخلي بفريق العمل",
      description:
        "تعزيز بيئة العمل والتقدير المشترك بين الزملاء.",
      items: [
        {
          id: "anuncio_interno",
          title: "إشعارات لوحة التحكم الداخلية",
          definition:
            "تفعيل تنبيهات داخل منصة BotMix لإعلام جميع الموظفين بأعياد ميلاد زملائهم لتهنئتهم ومشاركتهم الفرحة.",
        },
      ],
    },
  ],
};

export const BIRTHDAY_HELP_DATA = {
  es,
  en,
  pt,
  fr,
  ar,
};
